var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex flex-column pa-0 fill-height",staticStyle:{"min-height":"0"},attrs:{"fluid":"","pa-0":""}},[_c('FullHeader'),_c('BlueprintHeader'),_c('ForgeViewer',{staticStyle:{"flex":"1","min-height":"0","width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }